export default __webpack_public_path__ + "static/bg_image_other-bebde91dae02554c8eb603d8f2a76c78.png";